import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const deleteCashier = async (
  cashierId: string
): Promise<unknown> => {
  const response = await api.delete(
    `/cashiers/${cashierId}/`
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_CASHIERS_QUERY_KEY],
  })
  return response.body
}
